import axios from "axios";

const BASE_URL =
    process.env.REACT_APP_API_URL;



export const getAdvertisement = async (
    adminId,
    token
) => {
    try {
        const response = await axios.get(
            `$${BASE_URL}/food/superadmin/advertisement/admin/${adminId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    accept: "*/*",
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error(
            "GET Advertisement Error:",
            error
        );

        throw error;
    }
};

// ===============================
// ADD Advertisement
// ===============================

export const addAdvertisement = async (
    adminId,
    formData,
    token
) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/food/superadmin/advertisement/add/${adminId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type":
                        "multipart/form-data",
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error(
            "ADD Advertisement Error:",
            error
        );

        throw error;
    }
};

// ===============================
// UPDATE Advertisement
// ===============================

export const updateAdvertisement = async (
    adId,
    formData,
    token
) => {
    try {
        const response = await axios.put(
            `${BASE_URL}/food/superadmin/advertisement/edit/${adId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type":
                        "multipart/form-data",
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error(
            "UPDATE Advertisement Error:",
            error
        );

        throw error;
    }
};

// ===============================
// DELETE Advertisement
// ===============================

export const deleteAdvertisement = async (
    adId,
    token
) => {
    try {
        const response = await axios.delete(
            `${BASE_URL}/food/superadmin/advertisement/delete/${adId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error(
            "DELETE Advertisement Error:",
            error
        );

        throw error;
    }
};


export const getAllBanners = async (token) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/food/api/admin-banner/all`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error("GET Banner Error:", error);
        throw error;
    }
};

// ================= ADD =================

export const addBanner = async (
    formData,
    token
) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/food/api/admin-banner/add/1`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error("ADD Banner Error:", error);
        throw error;
    }
};

// ================= UPDATE =================

export const updateBanner = async (
    editId,
    formData,
    token
) => {
    try {
        const response = await axios.put(
            `${BASE_URL}/food/api/admin-banner/edit/${editId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type":
                        "multipart/form-data",
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error("UPDATE Banner Error:", error);
        throw error;
    }
};

// ================= DELETE =================

export const deleteBanner = async (
    editId,
    token
) => {
    try {
        const response = await axios.delete(
            `${BASE_URL}/food/api/admin-banner/delete/${editId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    accept: "*/*",
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error("DELETE Banner Error:", error);
        throw error;
    }
};
